import React, { useEffect, useRef, useState } from 'react';
import { downloadImage } from 'store/firebase';

const Image = (props) => {
  const { src, unloadComponent, alt = '', style } = props;
  const imgRef = useRef();
  const [isReady, setReady] = useState(false);

  useEffect(() => {
    downloadImage(src)
      .then((url) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onreadystatechange = (event) => {
          // eslint-disable-next-line no-unused-vars
          const blob = xhr.response;
          setReady(true);
        };
        xhr.open('GET', url);
        xhr.send();

        imgRef.current?.setAttribute('src', url);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [src])

  if (unloadComponent && !isReady) {
    return unloadComponent;
  }

  return (
    <img
      ref={imgRef}
      style={{ width: '100%', cursor: 'pointer', ...style }}
      alt={alt}
      onClick={() => window.open(imgRef.current.src, '_blank')}
    />
  )
}

export default Image;
